import React, {useState} from "react";
import {getMultiFactorResolver, signInWithPopup, TotpMultiFactorGenerator} from "firebase/auth";
import {auth, googleProvider} from "../../firebaseConfig";
import {Button, Paper, Stack, Typography} from "@mui/material";
import GoogleIcon from "@mui/icons-material/Google";
import MFACodeStep from "./MFACodeStep";


const GoogleAuth: React.FC<{ onMfaRequired: () => void }> = ({onMfaRequired}) => {
    const [nextStep, setNextStep] = useState<JSX.Element | null>(null);
    const [error, setError] = useState<string | null>(null);

    const signIn = async () => {
        let mfaError: any = null;
        try {
            console.info("Attempting Google sign-in...");
            await signInWithPopup(auth, googleProvider);
            console.info("Google sign-in successful.");
        } catch (error: any) {
            if (error.code === "auth/multi-factor-auth-required") {
                mfaError = error;
            } else {
                console.warn("Google sign-in failed:", error);
                setError("Inloggen met Google is niet mogelijk met het geselecteerde account.");
            }
        }

        if (!mfaError) return;

        console.info("2FA required");

        try {
            const mfaResolver = getMultiFactorResolver(auth, mfaError);
            const totpFactor = mfaResolver.hints.find(hint => hint.factorId === TotpMultiFactorGenerator.FACTOR_ID);
            if (totpFactor) {
                console.info("TOTP found, switching to MFA code step");
                onMfaRequired();
                setNextStep(<MFACodeStep mfaResolver={mfaResolver} enrollmentId={totpFactor.uid}/>);
            } else {
                throw new Error("Unsupported MFA method detected. Only TOTP is currently supported.");
            }
        } catch (resolverError) {
            console.error("Failed to get MFA resolver:", resolverError);
        }
    };

    if (nextStep) return nextStep;

    return (
        <Paper elevation={3} sx={{m: 2, flexGrow: 1}}>
            <Stack alignItems="left">
                <Typography variant="h6">Inloggen met Google</Typography>

                <Button
                    variant="contained"
                    startIcon={<GoogleIcon/>}
                    color="primary"
                    onClick={signIn}
                    fullWidth
                >
                    Verder met Google
                </Button>
                {error && <Typography variant="subtitle2" color="error">{error}</Typography>}
            </Stack>
        </Paper>
    );
};

export default GoogleAuth;
